import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {styles} from './styles';
import {isLoggedIn, getTokenRacerId} from '../../utils/isLoggedIn';
import {EventCalendar} from '../modal/EventCalendar';
import {ProfilePreview} from '../profile/ProfilePreview';
import Style from 'style-it';
import {fetchUserStartListEntries} from '../../data/StartListStreams';
import {stripLeadingZero} from '../../shared/util';
import {getGoalTime} from '../../utils/date';
import {getDisplayLocation} from '../../utils/location';
import _ from 'lodash';

/**
 * Rendering of race start list.
 *
 * @param {Array} athletes
 * @param {Array} followingIds
 * @param {Boolean} isMobile
 * @param {Boolean} isMe
 * @param {*} addCalendarProps
 * @param fetching
 * @return {XML}
 * @constructor
 */
export const StartList = ({athletes, isMobile, ...addCalendarProps, fetching = false, eventId, isRoster, t}) => {
  const loggedIn = isLoggedIn();
  const loggedInRacerId = getTokenRacerId();

  return (
    <div style={styles.listContainer}>
      {
        !isMobile && !isRoster &&
        <div style={styles.tableHeaders}>
          <div className="col-7 pl-0" style={styles.leftCell}>
            {t('Athlete')}
          </div>
          <div className="col-1">{t('Races')}</div>
          <div className="col-1">{t('PR')}</div>
          <div className="col-1">{t('Average')}</div>
          <div className="col-1" style={{minWidth: '98px'}}>{t('Goal Time')}</div>
          <div className="col-1"/>
        </div>
      }
      {
        !isMobile && isRoster &&
          <div style={styles.tableHeaders}>
            <div className="col-6 pl-0" style={styles.leftCell}>
              {t('Athlete')}
            </div>
            <div className="col-1">{t('Bib')}</div>
            <div className="col-1">{t('Age')}</div>
            <div className="col-1">{t('Gender')}</div>
            <div className="col-3" style={{textAlign: 'left'}}>
              {t('Location')}
            </div>
          </div>
      }

      {
        isMobile && !isRoster &&
        <div style={styles.tableHeaders}>
          <div className="col-8 pl-0 col-sm-9" style={{textAlign: 'left'}}>
            {t('Athlete')}
          </div>
          <div className="col-4 col-sm-3" style={{textAlign: 'center'}}>
            {t('Goal')}
          </div>
        </div>
      }

      {
        isMobile && isRoster &&
        <div style={styles.tableHeaders}>
          <div className="col-6 pl-0 col-sm-9" style={{textAlign: 'left'}}>
            {t('Athlete')}
          </div>
          <div className="col-6 col-sm-3" style={{textAlign: 'left'}}>
            {t('Location')}
          </div>
        </div>
      }

      {
        athletes
          .map((athlete, index) => (
          <StartListRow
            {...athlete}
            key={`starter-${index}-${athlete.RacerId}`}
            isMe={athlete.RacerId === loggedInRacerId}
            isMobile={isMobile}
            isLoggedIn={loggedIn}
            addCalendarProps={addCalendarProps}
            afterAdd={() => fetchUserStartListEntries(eventId)}
            canEdit={!isRoster}
            isRoster={isRoster}
          />
        ))
      }
      {
        <Loaders styles={styles} isMobile={isMobile} isRoster={isRoster} fetching={fetching} />
      }

    </div>
  )
};

function cleanTime(timeStr) {
  if(['00', '00:00'].includes(timeStr)) {
    return '-';
  }

  return stripLeadingZero(timeStr);
}

class StartListRowComponent extends Component {
  render() {
    const {
      ResultSummary,
      GoalTime,
      isMe,
      isMobile,
      RaceGoals,
      addCalendarProps,
      afterAdd,
      canEdit,
      isRoster,
      BibNum = '',
      Age = '',
      Gender = '',
      City = '',
      StateProvId = '',
      RacerId,
      history
    } = this.props;

    const {ResultCount, PersonalBest, AverageTime} = !isRoster ? ResultSummary : {};
    const state = _.get(StateProvId.split('_'), '[1]', '');
    const country = _.get(StateProvId.split('_'), '[0]', '');
    const locationStyle = {textAlign: 'left', textOverflow: 'ellipsis', overflow: 'hidden'};
    const url = RacerId ? `/athletes/${RacerId}` : null;
    const onClickHandler = () => { history.push(url) };

    const ConditionalWrap = ({condition, wrapIfTrue, wrapIfFalse, children}) => condition ? wrapIfTrue(children) : wrapIfFalse(children);
    const Row = ({children}) => (
      <ConditionalWrap
        condition={!!url}
        wrapIfTrue={(children) => Style.it(styles.pseudoStyles(isMobile, RacerId ? 'pointer' : 'default'),
          <div onClick={onClickHandler} className='start-list-row' style={{...styles.tableRow, color: 'inherit'}}>{children}</div>)}
        wrapIfFalse={(children) => Style.it(styles.pseudoStyles(isMobile, RacerId ? 'pointer' : 'default'),
          <div className='start-list-row' style={styles.tableRow}>{children}</div>)}
      >
        {children}
      </ConditionalWrap>
    )

    return (
      !isMobile ?
        !isRoster ?
        <Row>
          <div className='col-7' style={styles.profileColumn}>
            <ProfilePreview {...this.props} showAthletePhoto={true} nameOnly={isRoster} url={url} useLink={false} />
          </div>
          <div className="col-1 races-number" style={styles.dataColumn}>{ResultCount}</div>
          <div className="col-1 personal-records" style={styles.dataColumn}>{cleanTime(PersonalBest)}</div>
          <div className="col-1 average-time" style={styles.dataColumn}>{cleanTime(AverageTime)}</div>
          <div className='col-1 goal-time' style={styles.timeColumn()}>
            {GoalTime ? stripLeadingZero(getGoalTime(GoalTime)) : '-'}
          </div>
          <div className="col-1" style={{textAlign: 'center'}}>
            {
              isMe &&
              <div id='edit-button' onClick={(event) => {event.stopPropagation();event.preventDefault();}}>
                <EventCalendar
                  control='addEventToCalendar'
                  {...addCalendarProps}
                  isMobile={isMobile}
                  goalTime={GoalTime}
                  id="edit-button"
                  raceGoals={RaceGoals}
                  hasFutureDate={true}
                  isLoggedIn={true}
                  isEdit={canEdit}
                  buttonStyle={{}}
                  isStarter={true}
                  afterAdd={afterAdd}
                  isDarkButton={false}
                />
              </div>
            }
          </div>
        </Row>
        :
        <Row>
          <div className='col-6' style={styles.profileColumn}>
            <ProfilePreview {...this.props} showAthletePhoto={true} nameOnly={isRoster} url={url}/>
          </div>
          <div className="col-1 bib" style={styles.dataColumn}>{BibNum || '-'}</div>
          <div className="col-1 age" style={styles.dataColumn}>{Age || '-'}</div>
          <div className="col-1 gender" style={styles.dataColumn}>{Gender || '-'}</div>
          <div className='col-3 location' style={_.assign({}, styles.dataColumn, locationStyle)}>
            {getDisplayLocation(City, state, country) || '-'}
          </div>
        </Row>
      :
      <Row>
        <div className='col-6 col-sm-9' style={styles.profileColumn}>
          <ProfilePreview {...this.props} showAthletePhoto={true} nameOnly={isRoster} url={url}/>
        </div>
        <div className='col-6 col-sm-3' style={styles.midData}>
          {
            !isRoster &&
            <div style={styles.timeColumn()}>
              {GoalTime ? stripLeadingZero(getGoalTime(GoalTime)) : '-'}
            </div>
          }
          {
            isRoster &&
            <div style={_.assign({}, styles.dataColumn, locationStyle)}>
              {getDisplayLocation(City, state, country) || '-'}
            </div>
          }
        </div>
      </Row>
    );
  }
}

export const StartListRow = withTranslation()(withRouter(StartListRowComponent));

const Loaders = ({styles, isMobile, isRoster, fetching}) => {
  if(fetching) {
    window.scrollTo(0, 0);
  }

  return (
    <div style={styles.loadingContainer(fetching)}>
      <LoadingRow isMobile={isMobile} isRoster={isRoster} />
      <LoadingRow isMobile={isMobile} isRoster={isRoster} />
      <LoadingRow isMobile={isMobile} isRoster={isRoster} />
    </div>
  );
};

const LoadingRow = ({isMobile, isRoster}) => {
  return (
    !isMobile ?
      !isRoster ?
        <div style={styles.loadingRow}>
          <div className='col px-0' style={styles.loadingProfileColumn}>
            <div style={styles.loadingAvatar}/>
            <div style={styles.loadingProfile}>
              <div style={styles.loadingTitle}/>
              <div style={styles.loadingDetail}/>
            </div>
          </div>
          <div className="col-1" style={styles.dataColumn}>
            <div style={styles.loadingDatum}/>
          </div>
          <div className="col-1" style={styles.dataColumn}>
            <div style={styles.loadingDatum}/>
          </div>
          <div className="col-1" style={styles.dataColumn}>
            <div style={styles.loadingDatum}/>
          </div>
          <div className="col-1" style={styles.timeColumn()}>
            <div style={styles.loadingTime}/>
          </div>
          <div className="col-1" style={{textAlign: 'right'}}>
            <div style={styles.loadingButton}/>
          </div>
        </div>
        :
        <div style={styles.loadingRow}>
          <div className='col-6 pl-0' style={styles.loadingProfileColumn}>
            <div style={styles.loadingAvatar}/>
            <div style={styles.loadingProfile}>
              <div style={styles.loadingTitle}/>
              <div style={styles.loadingDetail}/>
            </div>
          </div>
          <div className="col-1" style={styles.dataColumn}>
            <div style={styles.loadingDatum}/>
          </div>
          <div className="col-1" style={styles.dataColumn}>
            <div style={styles.loadingDatum}/>
          </div>
          <div className="col-1" style={styles.dataColumn}>
            <div style={styles.loadingDatum}/>
          </div>
          <div className="col-3" style={styles.dataColumn}>
            <div style={styles.loadingDatum}/>
          </div>
        </div>
      :
      <div style={styles.loadingRow}>
        <div className='col-8' style={styles.loadingProfileColumn}>
          <div style={styles.loadingAvatar}/>
          <div style={styles.loadingProfile}>
            <div style={styles.loadingTitle}/>
            <div style={styles.loadingDetail}/>
          </div>
        </div>
        <div className='col-4' style={styles.midData}>
          <div style={styles.timeColumn()}>
            <div style={styles.loadingTime}/>
          </div>
        </div>
      </div>
  );
};



/** WEBPACK FOOTER **
 ** ./components/startList/StartList.js
 **/